module.exports = __webpack_public_path__ + "static/media/blog10.e98d72ca.jpg";